var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.9453 48.15C52.7713 40.0611 55.8699 23.8204 47.8793 11.8621C39.8799 -0.0961688 23.8188 -3.22938 11.9928 4.85055C0.166747 12.9395 -2.93182 29.1801 5.05875 41.1384C13.0582 53.0967 29.1192 56.2299 40.9453 48.15Z",
    fill: "#DE1414"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5532 45.4482C24.9551 45.4482 23.6944 44.9634 22.7622 44.0028C21.8299 43.0422 21.3594 41.8033 21.3594 40.295C21.3594 38.7868 21.8299 37.6286 22.7622 36.695C23.6944 35.7703 24.964 35.3034 26.5532 35.3034C28.1425 35.3034 29.3855 35.7703 30.2644 36.695C31.1523 37.6197 31.5873 38.8227 31.5873 40.295C31.5873 41.7673 31.1434 43.0332 30.2644 44.0028C29.3766 44.9634 28.1425 45.4482 26.5532 45.4482ZM26.5532 32.9961C25.621 32.9961 24.8841 32.6999 24.3425 32.0984C23.8009 31.5058 23.4636 30.6799 23.3304 29.6295L21.5103 13.7659C21.2706 11.9434 21.5991 10.4531 22.4958 9.30399C23.3925 8.14586 24.7509 7.57129 26.5532 7.57129C28.3556 7.57129 29.6341 8.14586 30.5041 9.30399C31.3742 10.4621 31.685 11.9524 31.4364 13.7659L29.6696 29.6295C29.5275 30.6799 29.199 31.5058 28.6841 32.0984C28.1691 32.6909 27.45 32.9961 26.5532 32.9961Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningCircleIcon);
export default __webpack_public_path__ + "static/media/warning-circle-icon.cc5616e447c34589aa2c60c1cbd33b56.svg";
export { ForwardRef as ReactComponent };